
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "POP_Q_staging",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/POP_Q_staging.vue